import React from 'react';
import { useEditFormContext } from '../context';
import { CircularProgress, Divider } from '@material-ui/core';
import { useStyles } from './styles';
import { Fields } from '../Fields';
import { AddQuestion } from '../AddQuestion';
import { CreatedQuestionsContainer } from '../CreatedQuestionsContainer';
import { PageFooter } from '../PageFooter';
import { IRouterProps } from 'pages/orderHistory';
import { SelectSuppliers } from '../SelectSuppliers';

export const Container = ({ router }: IRouterProps) => {
  const { isLoadingFormData } = useEditFormContext();
  const { container, loading, formContent } = useStyles({ isLoading: isLoadingFormData });

  return (
    <div className={container} id="form-container">
      <div className={loading}>
        <CircularProgress />
      </div>
      <div className={formContent}>
        <Fields />
        <SelectSuppliers />
        <Divider />
        <AddQuestion />
        <CreatedQuestionsContainer />
      </div>
      <PageFooter router={router} />
    </div>
  );
};
